import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-[72px] left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = { class: "w-[220px] justify-end flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Save & Display", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Add Sub-Form", -1)
const _hoisted_8 = { class: "mt-[72px]" }
const _hoisted_9 = {
  key: 0,
  class: "bg-primary-100"
}
const _hoisted_10 = { class: "flex items-start" }
const _hoisted_11 = { class: "h-[calc(100vh-146px)] flex-1 flex justify-center space-y-6 overflow-auto" }
const _hoisted_12 = { class: "h-[calc(100vh-146px)] w-[400px] p-6 bg-white flex flex-col relative" }
const _hoisted_13 = { class: "pb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-900 text-sm" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Field Types")
], -1)
const _hoisted_15 = { class: "flex rounded border border-neutral-100 mt-5 overflow-hidden" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "All Fields", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Fields w/ Sub-form", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "flex-1 overflow-auto" }
const _hoisted_21 = { class: "w-full grid grid-cols-2 gap-5" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "text-sm text-neutral-900 group-hover:text-primary-600 mb-2" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-sm text-neutral-900 group-hover:text-primary-600 mb-2" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "p-6"
}
const _hoisted_29 = { class: "border rounded-lg border-neutral-100" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "w-full px-6 border-t py-7" }
const _hoisted_32 = { class: "flex space-x-6" }
const _hoisted_33 = { class: "w-1/2" }
const _hoisted_34 = { class: "w-1/2" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import FormSection from "./FormSection.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TeleCpuLocationService from "@/classes/Settings/TeleCpuLocationService";
import TeleCpuOfficeService from "@/classes/Settings/TeleCpuOfficeService";
import { errorResponse } from "@/helpers/errorMessage";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import PageLoader from "@/components/loaders/PageLoader.vue"
import SimplePagination from "@/components/partials/SimplePagination.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { filters, items } from "@/interfaces/pages/FilterPageInterface";
import assignValues from "@/helpers/assignValues";

import InputModal from "./Modals/InputModal.vue";
import TextareaModal from "./Modals/TextareaModal.vue";
import DropdownModal from "./Modals/DropdownModal.vue";
import MultiselectModal from "./Modals/MultiselectModal.vue";
import RadioModal from "./Modals/RadioModal.vue";
import ToggleModal from "./Modals/ToggleModal.vue";
import CheckboxModal from "./Modals/CheckboxModal.vue";
import LinkModal from "./Modals/LinkModal.vue";
import DateTimeModal from "./Modals/DateTimeModal.vue";

import ContentModal from "./Components/ContentModal.vue";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const dataroute = useRoute();
const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const offices = ref(null);
const successMessage = ref<string>("Data has been successfully updated!");
const form = ref<{ name: string }>({
	name: "",
});
const tab = ref<any>(route.query.tab);
const datatab = ref<any>(route.query.datatab);
const errors = ref<any>();
const locationId = computed<any>(() => route.params.location);
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows || 5);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const officeId = ref<number>(0);
const filterDate = ref<any>(route.query.date);
const allCount = ref(0)

const newForm = ref<boolean>(false);
const selected = ref<boolean>(false);
const showInputModal = ref<boolean>(false);
const showTextareaModal = ref<boolean>(false);
const showDropdownModal = ref<boolean>(false);
const showMultiselectModal = ref<boolean>(false);
const showRadioModal = ref<boolean>(false);
const showToggleModal = ref<boolean>(false);
const showCheckboxModal = ref<boolean>(false);
const showLinkModal = ref<boolean>(false);
const showDateTimeModal = ref<boolean>(false);

const showSubfromModal = ref<boolean>(false);

const list = ref([
	{ fieldLabel: "Name of Personnel", fieldType: "input-field", width: "half"},
	{ fieldLabel: "Remarks", fieldType: "text-area", width: "whole"},
	{ fieldLabel: "Assigned Group", fieldType: "dropdown", width: "half" },
	{ fieldLabel: "To Be Done By", fieldType: "multi-select", width: "whole" },
	{ fieldLabel: "Is currently in rehabilitation?", fieldType: "radio-button", width: "whole" },
	{ fieldLabel: "Is currently in rehabilitation?", fieldType: "toggle", width: "whole" },
	{ fieldLabel: "Comorbid VAC/VAW", fieldType: "checkbox", width: "whole" },
	{ fieldLabel: "Attachment Link", fieldType: "link", width: "whole" },
	{ fieldLabel: "Schedule Date & Time", fieldType: "date-time", withTime: true, width: "whole" },
]);

const id = ref(3);

const add = () => {
  list.value.push({ fieldLabel: "Juan " + id.value, id: id.value++, fieldType: "input-field" });
};

const removeAt = (idx: number) => {
	list.value.splice(idx, 1);
};

const changeMeOptions = [
	{ id: '1', label: 'Change', value: 'Change'},
	{ id: '2', label: 'Me', value: 'Me'},
]

const formList = ref<{ title: string; modal: any; subform?: boolean; image: string; }[]>([
	{
		title: 'Input Field',
		modal: 'showInputModal',
		image: '/assets/icon/intervention/ic-text.svg',
	},
	{
		title: 'Text Area',
		modal: 'showTextareaModal',
		image: '/assets/icon/intervention/ic-textarea.svg',
	},
	{
		title: 'Dropdown',
		modal: 'showDropdownModal',
		subform: true,
		image: '/assets/icon/intervention/ic-dropdown.svg',
	},
	{
		title: 'Multi-Select',
		modal: 'showMultiselectModal',
		image: '/assets/icon/intervention/ic-multiselect.svg',
	},
	{
		title: 'Radio Button',
		modal: 'showRadioModal',
		subform: true,
		image: '/assets/icon/intervention/ic-radio-button.svg',
	},
	{
		title: 'Toggle',
		modal: 'showToggleModal',
		subform: true,
		image: '/assets/icon/intervention/ic-toggle.svg',
	},
	{
		title: 'Checkbox',
		modal: 'showCheckboxModal',
		subform: true,
		image: '/assets/icon/intervention/ic-checkbox.svg',
	},
	{
		title: 'Link',
		modal: 'showLinkModal',
		image: '/assets/icon/intervention/ic-link.svg',
	},
	{
		title: 'Date & Time',
		modal: 'showDateTimeModal',
		image: '/assets/icon/intervention/ic-datepicker.svg',
	},
]);

const openModal = (item: any) => {
	if (item.modal == 'showInputModal') {
		showInputModal.value = true;
	} else if (item.modal == 'showTextareaModal') {
		showTextareaModal.value = true;
	} else if (item.modal == 'showDropdownModal') {
		showDropdownModal.value = true;
	} else if (item.modal == 'showMultiselectModal') {
		showMultiselectModal.value = true;
	} else if (item.modal == 'showRadioModal') {
		showRadioModal.value = true;
	} else if (item.modal == 'showToggleModal') {
		showToggleModal.value = true;
	} else if (item.modal == 'showCheckboxModal') {
		showCheckboxModal.value = true;
	} else if (item.modal == 'showLinkModal') {
		showLinkModal.value = true;
	} else if (item.modal == 'showDateTimeModal') {
		showDateTimeModal.value = true;
	}
};

const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "Form Builder",
		count: 0,
		tab: "",
		href: `/settings/intervention-types/view`,
		allowed: true,
	},
	{
		name: "Activity Logs",
		count: 0,
		tab: "activity_logs",
		href: `/settings/intervention-types/view?tab=activity_logs`,
		allowed: true,
	},
]);

const save = (): void => {
	TeleCpuLocationService.update(
		{
			location: route.params.location,
		},
		form.value
	)
		.then((response: any) => {
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/intervention-types/index");
};

/**
 * METHODS
 */
const getData = (): void => {
	loading.value = false

	TeleCpuLocationService.edit({location: route.params.location}, pickBy(filters.value))
		.then(({ data }) => {

			form.value.name = data.item.name;
			offices.value = data.offices;
			
			items.value = data.offices.items;
			filters.value = assignValues(filters.value, data.offices);
			loading.value = false
			// dataTabletabs.value[1].count = response.data.archivedItemsCount;
			// dataTabletabs.value[2].count = response.data.activityLogsCount;
		})
		.catch((error: any) => console.log(error));
};

const reloadPage = async () => {
	return await router.push({
		path: `/settings/intervention-types/view`,
		query: pickBy({
			query: filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
			datatab: datatab.value,
			date: filterDate.value,
		}),
	});
};

const applyFilters = (search: any = null) => {
	filters.value.query = search;
	showFilter.value = false;

	getData();
};

const applyReset = () => {
	filterDate.value = "";
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const paginate = ({ page, rows }): void => {
	filters.value = Object.assign(filters.value, {
		page, rows
	})
	getData();
};

const updateTab = (currentTab: any) => {

	// const identify = typeof currentTab === "object";
	// tab.value = identify ? currentTab.tab : currentTab;
	filters.value.tab = currentTab;
	filters.value.page = 1;
	// filterSearch.value = "";
	// datatab.value = identify ? currentTab.datatab : "";
	applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
	showConfirmation.value = true;
	officeId.value = item.id;
};

const closeDeleteModal = (): void => {
	showSuccess.value = false;
};

const deleteRecord = (): void => {
	TeleCpuOfficeService.delete({
		location: locationId.value,
		telcpu: officeId.value,
	})
		.then(() => {
			showSuccess.value = true;
			showConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
	showRestoreConfirmation.value = true;
	officeId.value = item.id;
};

const closeRestoreModal = (): void => {
	showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
	TeleCpuOfficeService.restore({
		location: locationId.value,
		telcpu: officeId.value,
	})
		.then(() => {
			showRestoreSuccess.value = true;
			showRestoreConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
        page.value = 1;
		applyFilters(val);
	}, 1000)
);

onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { mainCustomClass: "intervention-generator" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/settings/intervention-types/index')))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"]),
          _createElementVNode("div", _hoisted_4, [
            (newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showSubfromModal.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_unref(route).query.tab != 'activity_logs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(FormSection, {
                      list: list.value,
                      onAdd: add,
                      onRemoveAt: removeAt
                    }, null, 8, ["list"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["text-center py-3 flex-1 cursor-pointer", selected.value ? 'text-gray-500' : 'bg-primary-100 text-primary-500']),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (selected.value = false))
                        }, _hoisted_17, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["text-center py-3 flex-1 cursor-pointer", selected.value ? 'bg-primary-100 text-primary-500' : 'text-gray-500']),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (selected.value = true))
                        }, _hoisted_19, 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formList.value, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.id
                          }, [
                            (!selected.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "col-span-1 rounded bg-gray-50 hover:bg-primary-300 flex flex-col items-center justify-center group p-6 h-[100px] cursor-pointer",
                                  onClick: ($event: any) => (openModal(item))
                                }, [
                                  _createElementVNode("p", _hoisted_23, _toDisplayString(item.title), 1),
                                  _createElementVNode("img", {
                                    src: item.image,
                                    class: "object-contain h-6 grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100",
                                    alt: "icon"
                                  }, null, 8, _hoisted_24)
                                ], 8, _hoisted_22))
                              : _createCommentVNode("", true),
                            (selected.value && item.subform)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "col-span-1 rounded bg-gray-50 hover:bg-primary-300 flex flex-col items-center justify-center group p-6 h-[100px] cursor-pointer",
                                  onClick: ($event: any) => (openModal(item))
                                }, [
                                  _createElementVNode("p", _hoisted_26, _toDisplayString(item.title), 1),
                                  _createElementVNode("img", {
                                    src: item.image,
                                    class: "object-contain h-6 grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100",
                                    alt: "icon"
                                  }, null, 8, _hoisted_27)
                                ], 8, _hoisted_25))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _createVNode(InputModal, {
                      show: showInputModal.value,
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (showInputModal.value = false)),
                      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showInputModal.value = false)),
                      title: "Input Field"
                    }, null, 8, ["show"]),
                    _createVNode(TextareaModal, {
                      show: showTextareaModal.value,
                      onClose: _cache[6] || (_cache[6] = ($event: any) => (showTextareaModal.value = false)),
                      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showTextareaModal.value = false)),
                      title: "Text Area"
                    }, null, 8, ["show"]),
                    _createVNode(DropdownModal, {
                      show: showDropdownModal.value,
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (showDropdownModal.value = false)),
                      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showDropdownModal.value = false)),
                      title: "Dropdown"
                    }, null, 8, ["show"]),
                    _createVNode(MultiselectModal, {
                      show: showMultiselectModal.value,
                      onClose: _cache[10] || (_cache[10] = ($event: any) => (showMultiselectModal.value = false)),
                      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (showMultiselectModal.value = false)),
                      title: "Multi-select"
                    }, null, 8, ["show"]),
                    _createVNode(RadioModal, {
                      show: showRadioModal.value,
                      onClose: _cache[12] || (_cache[12] = ($event: any) => (showRadioModal.value = false)),
                      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (showRadioModal.value = false)),
                      title: "Radio Button"
                    }, null, 8, ["show"]),
                    _createVNode(ToggleModal, {
                      show: showToggleModal.value,
                      onClose: _cache[14] || (_cache[14] = ($event: any) => (showToggleModal.value = false)),
                      onConfirm: _cache[15] || (_cache[15] = ($event: any) => (showToggleModal.value = false)),
                      title: "Toggle"
                    }, null, 8, ["show"]),
                    _createVNode(CheckboxModal, {
                      show: showCheckboxModal.value,
                      onClose: _cache[16] || (_cache[16] = ($event: any) => (showCheckboxModal.value = false)),
                      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (showCheckboxModal.value = false)),
                      title: "Checkbox"
                    }, null, 8, ["show"]),
                    _createVNode(LinkModal, {
                      show: showLinkModal.value,
                      onClose: _cache[18] || (_cache[18] = ($event: any) => (showLinkModal.value = false)),
                      onConfirm: _cache[19] || (_cache[19] = ($event: any) => (showLinkModal.value = false)),
                      title: "Link"
                    }, null, 8, ["show"]),
                    _createVNode(DateTimeModal, {
                      show: showDateTimeModal.value,
                      onClose: _cache[20] || (_cache[20] = ($event: any) => (showDateTimeModal.value = false)),
                      onConfirm: _cache[21] || (_cache[21] = ($event: any) => (showDateTimeModal.value = false)),
                      title: "Date & Time"
                    }, null, 8, ["show"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(route).query.tab === 'activity_logs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  (_unref(filters).tab != 'activity_logs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_unref(filters).tab == 'activity_logs')
                          ? (_openBlock(), _createBlock(ActivityLogsTable, {
                              key: 0,
                              items: _unref(items)
                            }, null, 8, ["items"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(SimplePagination, {
                      numRows: _unref(filters).rows,
                      currentPage: _unref(items).current_page,
                      "last-page": _unref(items).last_page,
                      onUpdate: _cache[22] || (_cache[22] = (value) => paginate(value))
                    }, null, 8, ["numRows", "currentPage", "last-page"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
      _createVNode(ContentModal, {
        show: showSubfromModal.value,
        title: "Add Conditional Form Trigger"
      }, {
        button: _withCtx(() => [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (showSubfromModal.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }),
          _createVNode(ButtonComponent, { customClass: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Submit ")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(MultiSelect, {
                options: changeMeOptions,
                label: "Parent Field",
                id: "parent_field",
                name: "parent_field",
                placeholder: "Select..",
                searchable: ""
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(MultiSelect, {
                options: changeMeOptions,
                label: "Option Value",
                id: "option_value",
                name: "option_value",
                placeholder: "Select..",
                searchable: ""
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})